import { Box, Button, Modal } from '@palmetto/palmetto-components';

const LIST_ITEM_STYLE = { paddingTop: '5px' };

interface CancelChangeOrderModalProps {
  isOpen: boolean;
  isCancelling: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const CancelChangeOrderModal = ({
  isOpen,
  isCancelling,
  onDismiss,
  onConfirm,
}: CancelChangeOrderModalProps) => (
  <Modal
    isOpen={isOpen}
    onDismiss={onDismiss}
    maxWidth="4xl"
    ariaLabelledBy="CancelChangeOrderModalHeader"
    fullScreenMobile
  >
    <Modal.Header id="CancelChangeOrderModalHeader" title="Cancel Change Order" onDismiss={onDismiss} />
    <Modal.Body background="secondary" fontSize="md">
      <Box gap="md">
        <p>Cancelling this change order will:</p>
        <ul>
          <li style={LIST_ITEM_STYLE}>1. Immediately stop the customer&apos;s signing link from working.</li>
          <li style={LIST_ITEM_STYLE}>
            2. Leave the account on its current executed contract terms — the signed contract does not change.
          </li>
          <li style={LIST_ITEM_STYLE}>3. Allow a new change order to be created right away.</li>
        </ul>
        <p>
          <b>This cannot be undone.</b>
        </p>
      </Box>
    </Modal.Body>
    <Modal.Footer justifyContent={'flex-end'}>
      <Box direction="row" gap="sm">
        <Button variant="secondary" tone="neutral" size="md" onClick={onDismiss} isDisabled={isCancelling}>
          Dismiss
        </Button>
        <Button tone="primary" size="md" variant="primary" onClick={onConfirm} isLoading={isCancelling}>
          Cancel Change Order
        </Button>
      </Box>
    </Modal.Footer>
  </Modal>
);
